import { createSlice } from '@reduxjs/toolkit';
import { PayscaleState } from './payscaleTypes';
import { 
  createPayscale, 
  fetchPayscales, 
  fetchPayscaleById, 
  updatePayscale, 
  deletePayscale 
} from './payscaleActions';



const initialState: PayscaleState = {
  payscales: [],
  selectedPayscale: undefined,
  loading: false,
  error: undefined,
};

const payscaleSlice = createSlice({
  name: 'payscale',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Payscale
      .addCase(createPayscale.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createPayscale.fulfilled, (state, action) => {
        state.loading = false;
        state.payscales.push(action.payload);
      })
      .addCase(createPayscale.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Payscales
      .addCase(fetchPayscales.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchPayscales.fulfilled, (state, action) => {
        state.loading = false;
        state.payscales = action.payload.data;
      })
      .addCase(fetchPayscales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Payscale by ID
      .addCase(fetchPayscaleById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchPayscaleById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPayscale = action.payload;
      })
      .addCase(fetchPayscaleById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Payscale
      .addCase(updatePayscale.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updatePayscale.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.payscales.findIndex(pay => pay.id === action.payload.id);
        if (index !== -1) {
          state.payscales[index] = action.payload;
        }
      })
      .addCase(updatePayscale.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Payscale
      .addCase(deletePayscale.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deletePayscale.fulfilled, (state, action) => {
        state.loading = false;
        state.payscales = state.payscales.filter(pay => pay.id !== action.payload.id);
      })
      .addCase(deletePayscale.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default payscaleSlice.reducer;
